import Sentry from '@sentry/react';
import { useRef } from 'react';
import config from '../util/config';

export default function useSentry(userId?: string): void {
  const sentryHasInitialized = useRef(false);

  if (sentryHasInitialized.current === false) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new Sentry.BrowserTracing()],
      tracesSampleRate: 0.05,
      enabled: window.location.hostname !== 'localhost',
      environment: config.environment,
      ignoreErrors: [],
    });
    Sentry.setUser({
      username: userId,
    });
    Sentry.setTag('project', 'vault (frontend)');
  }
}
